/**
 * NotMemberGate Component
 * 
 * Gate component shown when authenticated users try to access members-only events
 * but are not members of the club.
 * Part of Issue #604 - Allow public access to public events.
 */

import { Lock } from 'lucide-react';
import Button from './Button';
import { useNavigate } from 'react-router-dom';

interface NotMemberGateProps {
  clubSlug?: string;
}

export function NotMemberGate({ clubSlug }: NotMemberGateProps) {
  const navigate = useNavigate();
  
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4 bg-oro-bg">
      <Lock className="w-16 h-16 text-text-muted mb-4" />
      <h2 className="text-xl font-semibold mb-2 text-text-primary">Members Only</h2>
      <p className="text-text-secondary mb-6 text-center">This event is only visible to club members</p>
      {clubSlug && (
        <Button onClick={() => navigate(`/clubs/${clubSlug}`)}>
          View Club
        </Button>
      )}
    </div>
  );
}
